export default __webpack_public_path__ + "static/media/helping-about.d1112fe7.svg";